import * as React from 'react';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import { Box, Checkbox, Chip, FormControlLabel, Stack, TextField } from '@mui/material';
import Iconify from '../iconify/Iconify';

export default function InputGroupBtn({
    variant = 'outlined',
    id,
    name,
    getValue,
    className,
    isChecked = false,
    hiddenLabel,
    disabled,
    type,
    placeholder,
    required,
    size = 'small',
    readOnly,
    valueChange = [],
    label,
    autoFocus = false,
}) {
    const [value, setValue] = React.useState('');
    const [arrValue, setArrValue] = React.useState([]);
    const handleOnChange = (e) => {
        setValue(e.target.value);
    };

    React.useEffect(() => {
        valueChange && setArrValue(valueChange);
    }, [valueChange]);

    const handleAdd = () => {
        if (value) {
            setArrValue([
                ...arrValue,
                {
                    label: value,
                    value: generateUniqueId(),
                    checked: false,
                },
            ]);
            getValue &&
                getValue([
                    ...arrValue,
                    {
                        label: value,
                        value: generateUniqueId(),
                        checked: false,
                    },
                ]);
        }
        setValue('');
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            // Xử lý khi nhấn phím Enter
            // ...
            if (event.target.value) {
                setArrValue([
                    ...arrValue,
                    {
                        label: event.target.value,
                        value: generateUniqueId(),
                        checked: event.target.checked ? true : false,
                    },
                ]);
                getValue &&
                    getValue([
                        ...arrValue,
                        {
                            label: event.target.value,
                            value: generateUniqueId(),
                            checked: event.target.checked ? true : false,
                        },
                    ]);
            }
            setValue('');
        }
    };

    const generateUniqueId = () => {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        return uniqueId;
    };

    const handleClick = (item, index) => {
        if (item) {
            arrValue[index] = { ...item, checked: !item.checked };
            setArrValue([...arrValue]);
            getValue && getValue([...arrValue]);
        }
    };

    const handleDelete = (item, index) => {
        console.info('You clicked the delete icon.', item, index);
        arrValue.splice(index, 1);
        setArrValue([...arrValue]);
        getValue && getValue([...arrValue]);
    };

    return (
        <Stack direction="column" spacing={1}>
            <Paper component="form" sx={{ display: 'flex', position: 'relative', alignItems: 'center', width: '100%' }}>
                {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                <MenuIcon />
            </IconButton> */}
                <TextField
                    onKeyDown={handleKeyPress}
                    sx={{ flex: 1 }}
                    size={size}
                    fullWidth
                    type={type}
                    value={value}
                    disabled={disabled}
                    className={className}
                    required={required}
                    name={name}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    label={label}
                    hiddenLabel={hiddenLabel}
                    autoFocus={autoFocus}
                    onChange={handleOnChange}
                    id={id}
                    variant={variant}
                    // inputProps={{ 'aria-label': 'search google maps' }}
                />
                {/* <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                <SearchIcon />
            </IconButton> */}
                {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}
                <Box sx={{ position: 'absolute', right: 4 }}>
                    <IconButton onClick={handleAdd} color="primary" sx={{ p: '10px' }} aria-label="directions">
                        <Iconify icon="material-symbols:add-circle-outline" />
                    </IconButton>
                </Box>
            </Paper>
            <Stack direction="row" flexWrap={'wrap'} spacing={0} sx={{ gap: 1, paddingTop: 1 }}>
                {isChecked
                    ? arrValue?.length > 0 &&
                      arrValue.map((chip, index) => (
                          <Chip
                              variant="outlined"
                              key={index}
                              label={
                                  <FormControlLabel
                                      control={<Checkbox checked={chip.checked} size="small" />}
                                      label={chip.label}
                                      sx={{ fontSize: '14px', color: 'primary' }}
                                  />
                              }
                              onClick={() => handleClick(chip, index)}
                              onDelete={() => handleDelete(chip, index)}
                          />
                      ))
                    : arrValue?.length > 0 &&
                      arrValue.map((chip, index) => (
                          <Chip
                              variant="outlined"
                              key={index}
                              label={chip.label}
                              onClick={() => handleClick(chip, index)}
                              onDelete={() => handleDelete(chip, index)}
                          />
                      ))}
            </Stack>
        </Stack>
    );
}
